import { Pagination as AntdPagination, PaginationProps } from 'antd'

export const Pagination = (props: PaginationProps) => (
  <AntdPagination {...props} />
)

export default Pagination
